import { useEffect } from 'react';
import Logo from '@hiredigital/ui/Logo/PolyLogo';
import BaseLayout from '@components/Layout/BaseLayout';
import Hero from '@components/PageComponents/Hero/Hero';
import Link from '@components/Link';

import Styles from './Styles.module.scss';
import AgencyLogoSection from '@components/Abm/AgencyLogoSection';
import { setDefaultAccentColors } from '@components/Abm/defaults';

const EnterpriseRegisterPage = ({ ...props }) => {
  const pageHead = {
    title: `Schedule a Call | Poly`,
    meta: [
      {
        name: 'description',
        content: `Scale your marketing, creative and digital initiatives with Poly's exclusive talent network. Rigorously screened for your most important projects.`,
      },
    ],
  };
  const canonicalUrl = `${process.env.NEXT_PUBLIC_CANONICAL_URL}/schedule-call`;

  useEffect(setDefaultAccentColors, []);

  return (
    <BaseLayout
      canonicalUrl={canonicalUrl}
      pageHead={pageHead}
      removeMetaImage
      removeMetaSocial
      removeMetaJsonLd>
      <div className={Styles.container}>
        <Hero parent={Hero.Page.LOGIN}>
          <div className={Styles.topFormSection}>
            <div style={{ margin: '50px 0px 0 0px' }}>
              <Link href='/' className={Styles.logoContainer}>
                <Logo className={Styles.logo} type={Logo.Type.WHITE} site={'4'} />
              </Link>
              <AgencyLogoSection
                isScheduleCallSection
                isStandalonePage
                section={{
                  logos: [
                    'amazon',
                    'stripe',
                    'nike',
                    'airbnb',
                    'salesforce',
                    'atlassian',
                    'unilever_horizontal',
                    'uber',
                    'mckinsey',
                    'wayfair',
                    'kpmg',
                    'datadog',
                  ],
                  scheduleCallLogoHeading: 'Where our talents come from',
                }}
              />
            </div>
          </div>
        </Hero>
      </div>
    </BaseLayout>
  );
};

export default EnterpriseRegisterPage;
